import FontAwesomeIcon from './Icon';

export { default as IconTheme } from './Icon.theme';

export { Icon } from '@rivallapp/native-base';

export type { IFontAwesomeIconProps } from './Icon';

export default FontAwesomeIcon;
